import {api} from "../../shared/utils";
import {fetchAllPages} from "../../shared/utils/fetchAllPages";
import {environment} from "../../config/environment";

const baseUrl = environment.apiBaseURLClients;
const ROLES_PAGE_SIZE = 100;
const USERS_PAGE_SIZE = 100;

const buildQuery = (params = {}) => {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (value == null || value === '') return;
        query.set(key, value);
    });
    return query.toString();
};

export const listUsers = (params = {}) => {
    const query = buildQuery(params);
    return api.get(`${baseUrl}/auth/users${query ? `?${query}` : ''}`);
};

/** Todas as páginas: o backoffice lista os usuários de todos os tenants, sem teto. */
export const listAllUsers = (params = {}) => fetchAllPages((page) => (
    listUsers({...params, page, size: USERS_PAGE_SIZE})
), {firstPage: 0});

/** Permissões da sessão no sistema do login (`resources` no formato `MÉTODO:/endpoint`). */
export const getMyPermissions = () => api.get(`${baseUrl}/auth/users/me/permissions`);

export const createUser = (payload) => api.post(`${baseUrl}/auth/users`, payload);
export const updateUser = (id, payload) => api.put(`${baseUrl}/auth/users/${id}`, payload);
export const deleteUser = (id) => api.delete(`${baseUrl}/auth/users/${id}`);

/**
 * Acesso ao portal do cliente e visões da conta (BBF-179). Rota própria do identity, só para ADMIN e
 * SUPPORT: o PUT do usuário não mexe nisso. Responde a conta atualizada, como nas leituras.
 *
 * @param portal `{acesso, visoes}`, com as visões FINANCEIRA, LICENCAS, SUPORTE e USUARIOS_E_PERFIS
 */
export const definirAcessoAoPortal = (id, portal) => api.put(`${baseUrl}/auth/users/${id}/portal`, portal);

export const listRolesReference = () => fetchAllPages((page) => (
    api.get(`${baseUrl}/auth/roles?${buildQuery({page, size: ROLES_PAGE_SIZE})}`)
), {firstPage: 0});
export const listLicencasReference = () => api.get(`${baseUrl}/licencas?page=1&pageSize=300&sortBy=atualizado_em&order=desc`);
